import * as PropTypes from "prop-types"
import useFilteredOptions from "hooks/useFilteredOptions"
import { useT } from "react-polyglot-hooks"
import DropdownSelector from "../DropdownSelector"

export default function KindSelector(props) {
  const { field } = props
  const t = useT()

  const options = useFilteredOptions(field, () => [
    { value: "urbanite", label: t("car.kind.urbanite") },
    { value: "suv", label: t("car.kind.suv") },
    { value: "small-suv", label: t("car.kind.small-suv") },
    { value: "compact", label: t("car.kind.compact") },
    { value: "berlina", label: t("car.kind.berlina") },
    { value: "7seats", label: t("car.kind.7seats") },
    { value: "4x4", label: t("car.kind.4x4") }
  ])

  return (
    <DropdownSelector
      options={options}
      placeholder={t("renting.filter.kind_placeholder")}
      multiple
      dynamic
      {...props}
    />
  )
}

KindSelector.propTypes = {
  field: PropTypes.string.isRequired
}
